import { alpha, Box, Button, InputBase, Paper, styled, Typography } from '@mui/material'
import React, { useContext, useState } from 'react'
import SearchIcon from "@mui/icons-material/Search";
import DataTableComponent from '../../../components/common/DataTable/DataTable';
import { generateTopUpHistoryColumns } from '../helper';
import PageHeader from '../../../components/PageHeader';
import SidebarContext from '../../../context/SidebarContext';

const Search = styled("div")(({ theme }) => ({
    position: "relative",
    borderRadius: "12px",
    backgroundColor: "#FAFAFA",
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    // width: "230px",
    height: "40px",
    [theme.breakpoints.up("sm")]: {
      // marginLeft: theme.spacing(1),
      // width: "auto",
    },
    border: "1px solid #EEEEEE",
  }));
  
  const SearchIconWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }));
  
  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: "inherit",
    width: "100%",
    "& .MuiInputBase-input": {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create("width"),
      width: "230px",
      // [theme.breakpoints.up("sm")]: {
      //   width: "12ch",
      //   "&:focus": {
      //     width: "20ch",
      //   },
      // },
    },
  }));

function TopUpHistoryTable({ setAddFundDrawer, addFundDrawer }) {

    const { open } = useContext(SidebarContext);
    const [searchValue, setSearchValue] = useState("");
    const toUpColumns = generateTopUpHistoryColumns();
    const [userData, setUserData] = useState([
        {
            createdAt: "1st, March 2025",
            type: "Fund Wallet",
            emailId: "test@gmail.com",
            totalValue: "$12",
            expiredAt: "7th, March 2025",
            status: "Active"
        },
        {
            createdAt: "2nd, March 2025",
            type: "Gift Certificate",
            emailId: "test@gmail.com",
            totalValue: "$12",
            expiredAt: "7th, March 2025",
            status: "Active"
        },
        {
            createdAt: "3rd, March 2025",
            type: "Promo Code",
            emailId: "test@gmail.com",
            totalValue: "$12",
            expiredAt: "7th, March 2025",
            status: "Active"
        },
        {
            createdAt: "4th, March 2025",
            type: "Refferal Campaign",
            emailId: "test@gmail.com",
            totalValue: "$12",
            expiredAt: "7th, March 2025",
            status: "Active"
        }
    ]);

    const filteredRows = userData?.filter((row) => {
        const includesTerm = row?.emailId && row.emailId.toLowerCase().includes(searchValue?.toLowerCase());
        return includesTerm;
    });

    console.log(filteredRows);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ p: "24px 16px", paddingLeft: "0px" }}>
          <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search…"
              inputProps={{ "aria-label": "search" }}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </Search>
        </Box>
        <Box sx={{ display: "flex" }}>
          <Box>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "rgba(94, 23, 235, 1)",
                color: "white",
                border: "1px solid rgba(94, 23, 235, 1)",
                borderRadius: "4px",
                boxShadow: "none",
                whiteSpace: "nowrap",
                fontWeight: 600,
                marginTop: "20px",
                "&:hover": {
                  outline: "none",
                  color: "white",
                  backgroundColor: "rgba(94, 23, 235, 1)", // Remove border color on focus
                },
              }}
              onClick={() => setAddFundDrawer(true)}
            >
              Add Fund
            </Button>
          </Box>
        </Box>
      </Box>
      {filteredRows?.length > 0 && (
        <Box sx={{ display: "contents" }}>
          <Paper
            sx={{
              width: "100%",
              // height: "75vh",
              border: "1px solid #E5E5E8",
              borderRadius: "4px",
            }}
          >
            <DataTableComponent
              data={filteredRows || []}
              columns={toUpColumns}
              // searchHandler={searchHandler}
              // paginationHandler={paginationHandler}
              // pagination={pagination}
            />
          </Paper>
        </Box>
      )}
      {filteredRows && filteredRows.length <= 0 && (
        <Box sx={{ marginTop: "10%" }}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            {/* <img src={issue} alt="issue_not_found" /> */}
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "30px",
            }}
          >
            <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
              No records found
            </Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Typography>Try different keyword</Typography>
          </Box>
        </Box>
      )}
    </>
  )
}

export default TopUpHistoryTable